import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type {
  ActiveDiscountsResponseData,
  ActiveServicesResponseData,
  NotActiveServicesResponseData,
} from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const clientSubscriptionKeys = {
  all: () => ['clientSubscriptions'] as const,
  activeServices: (props: { url: string }) =>
    [...clientSubscriptionKeys.all(), 'activeServices', props.url] as const,
  notActiveServices: (props: { url: string }) =>
    [...clientSubscriptionKeys.all(), 'notActiveServices', props.url] as const,
  activeDiscounts: (props: { url: string }) =>
    [...clientSubscriptionKeys.all(), 'activeDiscounts', props.url] as const,
};

export const clientSubscriptionQueries = {
  activeServices: (props: { url: string }) =>
    queryOptions({
      queryKey: clientSubscriptionKeys.activeServices(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ActiveServicesResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),

  notActiveServices: (props: { url: string }) =>
    queryOptions({
      queryKey: clientSubscriptionKeys.notActiveServices(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<NotActiveServicesResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),

  activeDiscounts: (props: { url: string }) =>
    queryOptions({
      queryKey: clientSubscriptionKeys.activeDiscounts(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ActiveDiscountsResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
